import React, { FC } from 'react';
import { LinkText, Paragraph } from '@mediahuis/chameleon-react';

export type TextButtonProps = {
  onClick: () => void;
  message: string;
  selector: string;
  textStyling?: typeof Paragraph.defaultProps;
};

export const TextButton: FC<TextButtonProps> = ({ onClick, message, selector, textStyling }) => {
  return (
    <LinkText as="button" type="button" onClick={onClick} data-cy={selector}>
      <Paragraph {...textStyling}>{message}</Paragraph>
    </LinkText>
  );
};
